<template>
	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{ $t(`sidebar.warehouse-management.discount_refuse`) }}
					<div class="card-header-actions">
						<b-link @click="createForm" class="card-header-action btn-setting m-2" style="font-size: 15px"
								v-if="$can('create', 'warehouse-document')">
							<i class="fa fa-plus-circle"></i>
						</b-link>
					</div>
				</div>
				<b-card-body>
					<b-table-simple striped hover>
						<b-thead>
							<b-tr>
								<b-th class="text-center">{{ '№' }}</b-th>
								<b-th class="text-center">{{ $t('incomes.date') }}</b-th>
								<b-th class="text-center">{{ $t('incomes.name') }}</b-th>
								<b-th class="text-center">{{ $t('Создатель') }}</b-th>
								<b-th class="text-center">{{ $t('Дата создания') }}</b-th>
								<b-th class="text-center">{{ $t('promo-to-product.department') }}</b-th>
								<b-th class="text-center">{{ $t('incomes.reason') }}</b-th>
								<b-th class="text-center">{{ $t('incomes.actions') }}</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr v-for="(item, index) in list" :key="`item-${index}`">
								<b-td class="text-center">{{ index + 1 }}</b-td>
								<b-td class="text-center">{{ item.regDate }}</b-td>
								<b-td class="text-center">{{ item.regNumber }}</b-td>
								<b-td class="text-center">{{ item.docCreatedBy }}</b-td>
								<b-td class="text-center">{{ item.docCreatedDate }}</b-td>
								<b-td class="text-center">{{ item.fromDepartmentName }}</b-td>
								<b-td class="text-center">{{ item.reason }}</b-td>
								<b-td class="text-center">
									<b-link :to="`/warehouse-management/discount-refuse/view/${item.id}`">
										<i class="fa fa-eye" style="font-size: 18px"/>
									</b-link>
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
					<nav>
						<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page"
									  :prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')"
									  hide-goto-end-buttons/>
					</nav>
				</b-card-body>
			</b-card>
		</b-col>

		<vs-sidebar v-model="createModal" position-right parent="body" default-index="1" color="primary"
					class="create-modal priceSidebar" spacer :click-not-close="true">
			<b-card-group deck>
				<b-card header-tag="header" footer-tag="footer">
					<div slot="header" class="top-card d-flex justify-content-between items-center align-items-center">
						<h5 class="mt-1">{{ $t('incomes.create.create') }}</h5>
						<b-button variant="outline" @click.prevent="createModal=false">
							<i class="fa fa-close"></i>
						</b-button>
					</div>
					<b-overlay :show="loading">
						<b-form>
							<b-row class="mt-3">
								<b-col>
									<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
												  :label="$t('incomes.create.from-warehouse')" label-for="refName"
												  class="required ml-1" size="sm">
										<multiselect
											v-model="department"
											:options="departments"
											track-by="id"
											:show-labels="false"
											:allow-empty="true"
											label="name"
											:placeholder="$t('promo-to-product.department')"
											class="multiselect-pricing"
										/>
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
												  :label="$t('incomes.create.reg-number')" label-for="refName"
												  label-class="ml-1" @focus="$event.target.select()" class="required">
										<b-form-input v-model="form.regNumber" :required="true" size="sm" id="regNumber"
													  class="ml-1"
													  :placeholder="$t('incomes.create.reg-number')"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group breakpoint="lg" label-size="sm" :label-cols="'4'"
												  :label="$t('incomes.create.reg-date')" label-for="refName"
												  label-class="ml-1" class="required" size="sm">
										<date-picker v-model="form.regDate" size="sm" lang="ru" valueType="format"
													 :disabled="true" format="DD-MM-YYYY"
													 :placeholder=" $t('incomes.create.reg-date')"></date-picker>
									</b-form-group>
								</b-col>
								<b-col cols="12">
									<b-form-group breakpoint="lg" label-size="sm" :label-cols="'2'"
												  :label="$t('incomes.create.reason')" label-for="refName"
												  label-class="ml-1" class="required" size="sm">
										<b-form-input v-model="form.reason" :required="true" size="sm" id="reason"
													  :placeholder="$t('incomes.create.reason')"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<hr>
							<b-row>
								<b-col>
									<b-form-group breakpoint="lg" label-size="sm" label-cols="2"
												  :label="$t('incomes.create.product')" label-for="refName"
												  class="required mb-1">
										<multiselect v-model="item"
													 :options="items"
													 :searchable="true"
													 :show-labels="false"
													 :internal-search="false"
													 :loading="loading"
													 :close-on-select="true"
													 label="name"
													 :disabled="!department||!department.id"
													 track-by="id"
													 @search-change="loadItems($event)"
													 :placeholder="$t('incomes.create.product')">
											<template slot="singleLabel" slot-scope="props">
												<span v-if="props.option.wrapped">
													<strong><b>Уп.</b>  - </strong>{{
														props.option.barcode
													}} / {{ props.option.artikul }} / {{
														props.option.colorName
													}} / {{
														props.option.size
													}} / {{
														props.option.name ? props.option.name.substring(0, 30) : ''
													}} / {{ props.option.termOfItem }}
												</span>
												<span v-else>
													{{ props.option.artikul }} / {{
														props.option.barcode
													}} / {{
														props.option.name ? props.option.name.substring(0, 30) : ''
													}} / {{ props.option.termOfItem }}
												</span>
											</template>
											<template slot="option" slot-scope="option">
												<span v-if="option.option.wrapped">
													<strong><b>Уп.</b>  - </strong>{{
														option.option.barcode
													}} / {{ option.option.artikul }} / {{ option.option.colorName }} / {{
														option.option.size
													}} / {{
														option.option.name ? option.option.name.substring(0, 30) : ''
													}}
													<span> / <strong>{{
															$t('sale.kol-vo')
														}}:</strong> {{ option.option.count }} / <strong>Цена:</strong> {{
															option.option.price
														}} / <strong>{{
																$t('kirim.expirationDate')
															}}:</strong> {{
															option.option.termOfItem ? option.option.termOfItem : '--/--/----'
														}}</span>
												</span>
												<span v-else>
													{{
														option.option.barcode
													}} / {{
														option.option.name ? option.option.name.substring(0, 30) : ''
													}}
													<span> / <strong>Кол:</strong> {{ option.option.count }} / <strong>Цена:</strong> {{
															option.option.price
														}} <span
															v-if="option.option.termOfItem">/ <strong>Срок:</strong> {{
																option.option.termOfItem
															}}</span></span>
												</span>
											</template>
										</multiselect>
									</b-form-group>
								</b-col>
							</b-row>
							<hr>
							<b-row>
								<b-col class="mx-4">
									<b-table-simple striped hover>
										<b-thead>
											<b-tr>
												<b-th class="text-center">{{ '№' }}</b-th>
												<b-th class="text-center">{{ $t('goods.special-barcode') }}</b-th>
												<b-th class="text-center">{{ $t('incomes.create.product') }}</b-th>
												<b-th class="text-center">{{ $t('goods.barcode') }}</b-th>
												<b-th class="text-center">{{ $t('kirim.expirationDate') }}</b-th>
												<b-th class="text-center">{{ $t('pos.inventoryQty') }}</b-th>
												<b-th class="text-center">{{ $t('Старая цена') }}</b-th>
												<b-th class="text-center">{{ $t('Скидочная цена') }}</b-th>
												<b-th class="text-center">{{ $t('incomes.actions') }}</b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr v-for="(tmp,index) in form.whItems" :key="`items-${index}`"
												  :class="tmp.count>tmp.count1?'bg-danger':tmp.color&&tmp.color==='green'?'bg-green':''">
												<b-td class="text-center">{{ index + 1 }}</b-td>
												<b-td class="text-center">{{ tmp.barcode }}</b-td>
												<b-td class="text-center">{{ tmp.name }}</b-td>
												<b-td class="text-center">
													{{
														(tmp.multiBarcodes && tmp.multiBarcodes.length) ? tmp.multiBarcodes[0].barcode : ''
													}}
												</b-td>
												<b-td class="text-center">{{ tmp.termOfItem ? tmp.termOfItem : '' }}
												</b-td>
												<b-td class="text-center">{{ tmp.count }}</b-td>
												<b-td class="text-center">{{ tmp.oldPriceUzsForOneTimeDiscount }}</b-td>
												<b-td class="text-center">{{ tmp.price }}</b-td>
												<b-td class="text-center">
													<i @click="deleteItem(index)"
													   class="fa fa-trash text-danger pointer-event"/>
												</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
								</b-col>
							</b-row>
						</b-form>
					</b-overlay>
					<b-row class="mt-5">
						<b-col align="right">
							<b-button @click="save" :disabled="!form.whItems||!form.whItems.length"
									  class="btn btn-success">{{ $t('warehouse.document.saveAndFinish') }}
							</b-button>
						</b-col>
					</b-row>
				</b-card>
			</b-card-group>
		</vs-sidebar>
	</b-row>
</template>

<script>
import VisibleColumns from "@/views/warehouse-management/goods/blocks/VisibleColumns.vue";
import Multiselect from "vue-multiselect";
import ApiService from "@/services/api.service";
import {BOverlay} from "bootstrapVue2";
import {BTableSimple, BTbody, BTd, BTh, BThead, BTr} from 'bootstrap-vue';

const initForm = {
	action: "DISCOUNT_REFUSE",
	comment: null,
	contract: null,
	contractId: null,
	contragentId: null,
	contragentName: "",
	currencyId: null,
	customsRegDate: "",
	documentType: "NAKLADNOY",
	eimzoData: null,
	fromCurrencyRate: null,
	fromDepartmentId: null,
	fromDepartmentName: null,
	fromEmployeeId: null,
	fromEmployeeName: null,
	id: null,
	initiatorId: null,
	numberGTD: "",
	reason: null,
	regDate: null,
	regNumber: "",
	responsible1Id: null,
	responsible1Name: "",
	responsible2Id: null,
	responsible2Name: "",
	toCurrencyRate: null,
	toDepartmentId: null,
	toDepartmentName: null,
	toEmployeeId: null,
	toEmployeeName: "",
	whItems: []
}
export default {
	name: 'discount-refuse',
	components: {BTableSimple, BThead, BTbody, BTr, BTd, BTh, BOverlay, Multiselect, VisibleColumns},
	data() {
		return {
			loading: false,
			createModal: false,
			form: {},
			departments: [],
			item: null,
			items: [],
			department: {},
			list: [],
			total: 0,
			payload: {
				page: 1,
				limit: 20
			}
		}
	},
	computed: {
		allTotalCount() {
			return 0
		},
		computedDepCurrencyName() {
			return localStorage.getItem('depCurrencyName');
		}
	},
	watch: {
		'department': {
			handler(f) {
				console.log('qwe')
				if (f)
					this.loadItems('')
				else
					this.items = []
			}
		},
		'item': {
			handler(i) {
				if (i)
					this.addItem()
			}
		}
	},
	methods: {
		deleteItem(index) {
			if (this.form.whItems.length > 1) {
				this.form.whItems.splice(index, 1)
			} else {
				this.form.whItems = []
			}
			this.$forceUpdate()
		},
		addItem() {
			if (this.form.whItems && this.form.whItems.length) {
				let has = null, index = null;
				this.form.whItems.forEach((wh, ind) => {
					if (wh.id === this.item.id && wh.termOfItem === this.item.termOfItem) {
						has = wh
						index = ind
					}
				})
				if (!has)
					this.form.whItems.unshift({...this.item})
				else {
					this.form.whItems[index].color = 'green'
					setTimeout(() => {
						this.form.whItems[index].color = ''
					}, 1000)
				}
			} else {
				this.form.whItems = [{...this.item}]
			}
			this.item = null
		},
		async getList() {
			this.loading = true
			await ApiService.post(`/warehouse-document/search/discount-refuse`, this.payload).then(res => {
				this.list = res.data && res.data.items ? res.data.items : []
				this.total = res.data && res.data.total ? res.data.total : 0
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async createForm() {
			this.loading = true
			await ApiService.post(`/warehouse-document/create`, initForm).then(res => {
				this.getDepartments();
				this.form = res.data
				this.department = null
				this.createModal = true
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async loadItems($event) {
			if (this.department && this.department.id) {
				this.loading = true
				await ApiService.get(`/item/wh-search-for-dep/discount/${$event && $event !== '' ? $event : 'null'}/${this.department.id}`).then(res => {
					this.items = res.data
					this.item = null
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}).finally(f => {
					this.loading = false
				})
			} else {
				this.$vs.notify({
					title: 'Tuzulma tanlanmagan',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		async getDepartments() {
			this.loading = true
			await ApiService.get(`/department/get-my-departments`).then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async save() {
			this.loading = true
			this.form.fromDepartmentId = this.department.id
			this.form.documentStatus = "READY"
			console.log('asdasd')
			await ApiService.post(`/warehouse-document/discount-refuse`, this.form).then(res => {
				this.createModal = false
				this.$vs.notify({
					title: 'Успешно сохранено!',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.getList();
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>

</style>
